const Line = () => {
  return <div className="d-none d-lg-block line col-lg-3"></div>;
};

export default Line;
